import { Box, Container, Flex, Text, Image, Divider, SimpleGrid, Input, InputGroup, FormControl, FormLabel, Textarea, Select, InputLeftElement, ButtonGroup, Button, Center, Heading, IconButton, FormErrorMessage, Checkbox, useDisclosure } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LoadingScreen from "components/loading-screen";
import AuthService from "services/auth/auth-service";
import Layout from "scenes/layouts";
import { FiFacebook, FiGlobe, FiInstagram, FiTwitter } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";
import { Field, Formik, useFormik } from "formik";
import LogosNotification from "utils/notification-utils";
import { EditIcon } from "@chakra-ui/icons";
import { relative } from "path";
import { BsPencil } from "react-icons/bs";
import AppConsts from "libs/appconst";
import VoucherService from "../../services/vouchers/voucher-service";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import ProgramService from "../../services/programs/program-service";
import ConfirmDialog from "../../components/confirm-dialog";
import BannerService from "../../services/banners/banner-service";

const formInitialValue = {
    name: '',
    redirectUrl: '',
    checkoutUrl: '',
    isRedirectToNewWindow: false,
    status: false,
    sequence: 0
};

const EditBannerScene = (): ReactElement => {
    const navigate = useNavigate();
    const { bannerId } = useParams();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [isSaving, setSaving] = useState<boolean>(false);
    const [banner, setBanner] = useState<any>(null);
    const [formValue, setFormValue] = useState<any>(formInitialValue);

    useEffect(() => {
        setLoading(true);
        BannerService.Get(bannerId).then((res: any) => {
            setBanner(res.result);
            var status = { status: res.result.status == 0 ? true : false };

            setFormValue({ ...res.result, ...status });
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const handleFormSubmit = (values: any) => {
        setSaving(true);
        BannerService.Update(
            bannerId,
            values.name,
            values.redirectUrl,
            values.checkoutUrl,
            values.isRedirectToNewWindow,
            values.status ? 0 : 10,
            values.sequence
        ).then((res: any) => {
            LogosNotification.Success("Banner berhasil diperbaharui.");
            navigate(`/banners/${bannerId}`);
        }).finally(() => {
            setSaving(false);
        });
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} pt={10}>
                <Box>
                    <Flex>
                        <Text fontSize={'3xl'} fontWeight={"bold"}>Edit Banner {banner.name}</Text>
                    </Flex>
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                        {
                            ({ handleSubmit, errors, touched, values, setFieldValue }) => (
                                <form onSubmit={handleSubmit} noValidate={true}>
                                    <Box rounded={'lg'} fontSize={'sm'} border={'1px solid'} borderColor={'blackAlpha.400'}>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.name && touched.name)}>
                                                    <FormLabel htmlFor='name'>Nama Banner</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='name'
                                                        placeholder='Nama Banner'
                                                        name={'name'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Nama Banner wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.name}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.redirectUrl && touched.redirectUrl)}>
                                                    <FormLabel htmlFor='redirectUrl'>Redirect Url</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='redirectUrl'
                                                        placeholder='Redirect Url'
                                                        name={'redirectUrl'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Redirect Url wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.redirectUrl}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.checkoutUrl && touched.checkoutUrl)}>
                                                    <FormLabel htmlFor='checkoutUrl'>Checkout Url</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='checkoutUrl'
                                                        placeholder='Checkout Url'
                                                        name={'checkoutUrl'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Checkout Url wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.checkoutUrl}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.sequence && touched.sequence)}>
                                                    <FormLabel htmlFor='name'>Urutan</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='sequence'
                                                        placeholder='Nomor Urutan'
                                                        name={'sequence'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Nomor Urutan wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.sequence}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.isRedirectToNewWindow && touched.isRedirectToNewWindow)}>
                                                    <FormLabel htmlFor='isRedirectToNewWindow'>Buka Halaman Baru?</FormLabel>
                                                    <Field
                                                        type="checkbox"
                                                        id='isRedirectToNewWindow'
                                                        name={'isRedirectToNewWindow'}
                                                        checked={values.isRedirectToNewWindow}
                                                        style={{ width: '22px', height: '22px' }}
                                                    >
                                                    </Field>
                                                    <FormErrorMessage>{errors.isRedirectToNewWindow}</FormErrorMessage>
                                                </FormControl>
                                                <FormControl isRequired isInvalid={!!(errors.status && touched.status)}>
                                                    <FormLabel htmlFor='status'>Aktif?</FormLabel>
                                                    <Field
                                                        type="checkbox"
                                                        id='status'
                                                        name={'status'}
                                                        checked={values.status}
                                                        style={{ width: '22px', height: '22px' }}
                                                    >
                                                    </Field>
                                                    <FormErrorMessage>{errors.status}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />

                                        <Box px={8} py={8}>
                                            <ButtonGroup gap={2}>
                                                <Button type={'submit'} isLoading={isSaving}>Simpan</Button>
                                                <Button variant={'outline'} onClick={() => { navigate(`/banners/${bannerId}`) }}>Kembali</Button>
                                            </ButtonGroup>
                                        </Box>
                                    </Box>
                                </form>
                            )
                        }
                    </Formik>
                </Box>
            </Container>
        </Layout >
    );
};

export default EditBannerScene;